<template>
  <div class="page-set-pwd">
    <div class="title-box">
      <div class="title">修改密码</div>
      <div class="line"></div>
    </div>

    <div class="pwd-box">
      <div class="pwd-content">
        <!-- <div class="pwd-text">原密码</div>
        <el-input
          class="pwd-input"
          v-model="oldPwd"
          placeholder="填写原密码"
          type="password"
          show-password
        ></el-input> -->
        <div class="pwd-text">新密码</div>
        <el-input class="pwd-input" v-model="newPwd" placeholder="填写新密码" type="password" show-password></el-input>
        <div class="pwd-text">确认密码</div>
        <el-input class="pwd-input" v-model="confirmPwd" placeholder="填写确认密码" type="password" show-password></el-input>
        <div class="confirm-btn-box">
          <hm-button class="confirm-btn" @click="confirmSetPwd">确认</hm-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sha256 from "js-sha256";
import { updatePwd, updateUser } from "../api/user";
export default {
  name: "SetPwd",
  data() {
    return {
      pwd: "",
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
    };
  },
  created() {
    this.pwd = this.$store.getters.user.password;
  },
  mounted() { },
  computed: {},
  methods: {
    confirmSetPwd() {
      let reg = /^(?=.*[A-Za-z])(?=.*[0-9])[a-z0-9A-Z]{10,}$/;
      if (!reg.test(this.newPwd)) {
        this.$message('密码为字母+数字组合且长度不小于10')
      } else if (this.newPwd != this.confirmPwd) {
        this.$message("两次密码不一致");
      } else {
        updateUser({
          id: this.$store.getters.user.id,
          password: this.newPwd,
        }).then((res) => {
          this.$message({
            type: "success",
            message: "修改密码成功，请重新登录",
          });
          this.$store.dispatch("setUser", null);
        });
      }
    },
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-set-pwd {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.title-box {
  padding: 0 100px 0 31px;
  height: 22px;
  display: flex;
  align-items: center;
  margin-top: 60px;

  .title {
    height: 22px;
    line-height: 22px;
    margin-right: 22px;
  }

  .line {
    flex: 1;
    height: 1px;
    background: #a4b8cf;
  }
}

.pwd-box {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.pwd-text {
  font-size: 14px;
  margin-bottom: 9px;
}

.pwd-input {
  width: 413px;
  margin-bottom: 26px;
  border-radius: 8px;
}

.confirm-btn-box {
  display: flex;
  justify-content: center;
}

.confirm-btn {
  width: 172px;
}
</style>



// WEBPACK FOOTER //
// src/views/setPwd.vue